<template>
  <div class="cmpprange">
    <div class="cmpprange_content">
      <SolfigrNodeCompare
        ref="form"
        :namespace="tmpNamespace"
        :primaryNamespace="primaryNamespace"
        class="flex-1"
        :hotkeysPressed="hotkeysPressed"
        @close="close"
      />
    </div>
  </div>
</template>

<script>
import SolfigrNodeCompare from '@/components/Dialogs/Solfigr/SolfigrNodeCompare'

export default {
  name: 'SolfigrNodeCompareDialog',
  components: {
    SolfigrNodeCompare,
  },
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'solfigr-nodecompare-dialog')
    },
  },
  computed: {
    hotkeysPressed() {
      return this.$store.getters.hotkeys_pressed
    },
    tmpNamespace() {
      return this.dialog.tmpNamespace || ''
    },
    primaryNamespace() {
      return this.dialog.namespace || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.cmpprange {
  display: flex;
  flex-direction: column;
  --cmpprange-clr-black: var(--clr-black-1);
  width: 100vw;
  aspect-ratio: 16/7.4;
  max-height: calc(var(--vh-100) - 3rem);
  &_content {
    background: var(--cmpprange-clr-black);
    display: flex;
    flex: 1;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
  }
}

@media (max-width: 1023px) {
  .cmpprange {
    aspect-ratio: unset;
    height: calc(var(--vh-100) - 3rem);
  }
}
</style>
